// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3ssCG","actions":"GroupTable_actions__3IhSn","deleteModalFooter":"GroupTable_deleteModalFooter__31Xgb"};